// Module
var code = "<transition name=\"el-fade-in-linear\"> <i v-if=\"!loading\" class=\"el-icon-loading\"></i> <img v-else-if=\"loading\" :src=\"src\"> </transition>";
// Exports
module.exports = code;